import { AspectRatio, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Heading, Flex, Box, Image } from "@chakra-ui/react";
import { MotionBox, Link } from "../../../../src/shared/components";
import { StaticImage } from "gatsby-plugin-image";
import * as React from 'react';
export default {
  AspectRatio,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Heading,
  Flex,
  Box,
  Image,
  MotionBox,
  Link,
  StaticImage,
  React
};